module.exports = __webpack_public_path__ + "static/media/3.8_preview.83e76b10.png";